export const FETCH_ROOM_LIST_REQUEST = "FETCH_ROOM_LIST_REQUEST";
export const FETCH_ROOM_LIST_SUCCESS = "FETCH_ROOM_LIST_SUCCESS";
export const FETCH_ROOM_LIST_FAILURE = "FETCH_ROOM_LIST_FAILURE";
